/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CustomerSupportIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M18.6991585,9.79382889 L18.6991585,10.7194951 C18.5251332,11.584993 17.729986,12.5708275 16.8478261,12.5708275 L13.1451613,12.5708275" />
      <path d="M19.6248247,8.40532959 C19.6248247,9.17178121 19.002777,9.79382889 18.2363254,9.79382889 L17.3106592,9.79382889 L17.3106592,7.01683029 L18.2363254,7.01683029 C19.0037027,7.01683029 19.6248247,7.63887798 19.6248247,8.40532959 Z" />
      <rect x="10.3064516" y="12.1419355" width="2.83870968" height="1" rx="0.5" />
      <rect x="10.2354839" y="11.9645161" width="2.98064516" height="1.06451613" rx="0.532258065" />
      <ellipse cx="11.756662" cy="7.94249649" rx="5.55399719" ry="6.44660389" />
      <path d="M17.2584516,7.83092325 C17.0718373,7.86208709 16.9429846,7.85169914 16.7552595,7.90067089 C14.863568,8.38742035 13.6483534,7.47179712 12.6075344,5.03656582 C11.9821543,6.63630948 10.0282581,7.90067089 8.42426367,7.90067089 C7.63448527,7.90067089 6.95467602,7.68400802 6.27375596,7.20913049" />
      <path d="M8.97966339,13.9593268 L8.97966339,15.6292286 L4.3430014,17.2852454 C3.23775596,17.6805049 2.5,18.7274334 2.5,19.9002525 L2.5,22.108892 L2.52617655,22.108892 C8.9605465,23.2863729 15.122929,23.2863729 21.013324,22.108892 L21.013324,19.9002525 C21.013324,18.7274334 20.275568,17.6805049 19.1703226,17.2852454 L14.5336606,15.6292286 L14.5336606,13.9593268" />
    </g>
  </svg>
);

export default CustomerSupportIcon;
